import {
  DAMAGED_CONDITION,
  GOOD_CONDITION,
  NEW_CONDITION,
  PERFECT_CONDITION,
} from '~/models/ListingProduct.api.model';
import { Category as CategoryType } from '~/models/Category.models';
import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
import {
  DEFAULT_MONTHLY_PAYMENT_PERIOD,
  DEFAULT_PLAN_ID,
} from '~/utils/pdp/queryParamHelpers';
import { COMPONENT_PRODUCT_LIST } from '~/models/MarkupComponentNames.model';
import { findFilterAssociatedProductList } from '~/utils/filters/findFilterAssociatedProductList';

export const initializeFiltersIfListComponentExists = (
  responseData?: {
    PageContent: BaseMarkupComponent[];
    [key: string]: unknown;
  } | null,
  isPreOwnedPage?: boolean,
) => {
  if (!responseData) {
    return;
  }

  const productList =
    findFilterAssociatedProductList(responseData.PageContent) ??
    responseData.PageContent?.find(
      (c) => c.Component?.toLocaleLowerCase() === COMPONENT_PRODUCT_LIST,
    );

  if (!productList) {
    return;
  }

  const filterStore = useFilterStore();
  const productStore = useProductStore();

  let defaultDownPayment = Number(DEFAULT_MONTHLY_PAYMENT_PERIOD);
  let defaultPlanId = Number(DEFAULT_PLAN_ID);
  for (const component of responseData?.PageContent ?? []) {
    if (
      component?.Component.toLocaleLowerCase() === COMPONENT_PRODUCT_LIST &&
      component?.DefaultPlanId
    ) {
      defaultPlanId = component?.DefaultPlanId;
      break;
    }

    if (
      component?.FilterSettings?.DefaultDownpaymentTime &&
      component?.FilterSettings?.DefaultPlanId
    ) {
      defaultDownPayment = component.FilterSettings.DefaultDownpaymentTime;
      defaultPlanId = component.FilterSettings.DefaultPlanId;
      break;
    }
  }

  const { Data, Category: categoryName } = productList;

  productStore.setProducts(Data);

  // Whether we have only used products or only new products in the list.
  // If we implement the possibility to have mixed used/new products in a list,
  // we need to change this to counting the majority or something.
  // prettier-ignore
  const hasPreOwnedProducts = (
    productStore.conditionsInUnwrappedProductsMap[PERFECT_CONDITION.toLocaleLowerCase()] ||
    productStore.conditionsInUnwrappedProductsMap[GOOD_CONDITION.toLocaleLowerCase()] ||
    productStore.conditionsInUnwrappedProductsMap[DAMAGED_CONDITION.toLocaleLowerCase()]
) && !productStore.conditionsInUnwrappedProductsMap[NEW_CONDITION.toLocaleLowerCase()];

  let category: SUPPORTED_PRODUCT_CATEGORIES = CategoryType.phones;
  if (categoryName === CategoryType.accessory) {
    category = CategoryType.accessory;
  } else if (isPreOwnedPage === true || hasPreOwnedProducts) {
    category = CategoryType.used;
  }

  filterStore.initializeFilters(category, defaultDownPayment, defaultPlanId);
};
